import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledTestimonialItemWrapper = styled(Box)`
  position: relative;

  &::before {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -2px;
    width: 0px;
    height: 4px;
    background: ${({ theme }) => theme.palette.gradients.secondary};
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition:
      width 0.1s ease,
      height 0.1s ease;
    border-radius: 50%;
  }
  &:hover:before {
    width: 97%;
    border-radius: 999px;
  }
`;
